import React from "react";
import type { FC } from "react";
import { Box, MenuItem, Select } from "@mui/material";
import type { Option } from "@fas/cpa-cabinet-ui";
import LegendItem from "./LegendItem";
import type { LineInfoType } from "./types/Chart.types";
import LinearGradient from "../LinearGradient/LinearGradient";

type Props = {
  payload: LineInfoType[];
  onChangeLegend: (arg0: string, arg1: boolean) => unknown;
  period: string;
  disabled: boolean;
  periods: Option[];
  onChangePeriod: (arg0: string) => unknown;
};

const ChartLegend: FC<Props> = ({
  payload,
  onChangeLegend,
  period,
  periods,
  onChangePeriod,
  disabled,
}: Props) => (
  <Box
    display="flex"
    justifyContent="space-between"
    alignItems="center"
    sx={{
      marginTop: {
        xs: "10px",
        md: "20px",
      },
    }}
  >
    <Box>
      <svg
        height={0}
        width={0}
        style={{
          position: "absolute",
        }}
      >
        <defs>
          {payload.map(({ dataKey, colors }: LineInfoType) => (
            <LinearGradient
              key={dataKey}
              id={`legend-${dataKey}`}
              colors={colors}
            />
          ))}
        </defs>
      </svg>
      {payload.map((item: LineInfoType) => (
        <LegendItem
          key={item.dataKey}
          hide={item.hide}
          dataKey={item.dataKey}
          label={item.labelLegend}
          onChange={onChangeLegend}
          style={{
            fill: `url(#legend-${item.dataKey})`,
          }}
        />
      ))}
    </Box>
    <Select
      variant="filled"
      disableUnderline
      data-testid="period-select"
      sx={{
        width: 160,
        lineHeight: 1.5,
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4,
        "& .MuiSelect-select": {
          paddingTop: "13px",
          paddingBottom: "13px",
        },
      }}
      value={period}
      onChange={({ target: { value } }: any): unknown => onChangePeriod(value)}
      disabled={disabled}
    >
      {periods.map(({ title, value }: Option) => (
        <MenuItem key={value} value={value}>
          {title}
        </MenuItem>
      ))}
    </Select>
  </Box>
);

export default ChartLegend;
